var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"success"},[_c('section',{staticClass:"section"},[_vm._m(0),_c('div',{staticClass:"row align-center"},[_c('font-awesome-icon',{staticClass:"success-icon",attrs:{"icon":'spinner',"spin":""}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row align-center"},[_c('h1',{staticClass:"success-title"},[_vm._v("Seu boleto está sendo emitido...")])])
}]

export { render, staticRenderFns }